import { render, staticRenderFns } from "./MainLayoutSidebar.vue?vue&type=template&id=2dcac174&"
import script from "./MainLayoutSidebar.vue?vue&type=script&lang=js&"
export * from "./MainLayoutSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MainLayoutSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB06-CV-01\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dcac174')) {
      api.createRecord('2dcac174', component.options)
    } else {
      api.reload('2dcac174', component.options)
    }
    module.hot.accept("./MainLayoutSidebar.vue?vue&type=template&id=2dcac174&", function () {
      api.rerender('2dcac174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/layouts/MainLayoutSidebar.vue"
export default component.exports